export const layoutConstant = {
  topbarHeight: 40,
  headerHeight: 80,
  mobileNavHeight: 64,
  containerWidth: 1200,
  mobileHeaderHeight: 64,
  grocerySidenavWidth: 280,
};

export const footMartLayoutConstant = {
  topbarHeight: 40,
  headerHeight: 80,
  mobileNavHeight: 64,
  containerWidth: 1600,
  mobileHeaderHeight: 64,
  grocerySidenavWidth: 600,
};

export const gridWrapperConstant = {
  colTotal: 12,
};
